export const editor = 'Editor'
export const configuration = 'Configuration'
export const preview = 'Preview'

export const user = 'User'

export const width = 'Width'
export const height = 'Height'
export const thickness = 'Thickness'
export const length = 'Length'
export const border = 'Border'
export const borderSide = 'BorderSide'
export const gap = 'Gap'
export const gapSide = 'GapSide'
export const solderSide = 'SolderSide'
export const componentSide = 'ComponentSide'
export const offset = 'Offset'

export const adapter = 'Adapter'
export const adapterEdge = 'AdapterEdge'
export const adapterPlate = 'AdapterPlate'
export const adapterPlateProperties = 'AdapterPlateProperties'
export const adapterPlateEdge = 'AdapterPlateEdge'
export const adapterPlateEdgeProperties = 'AdapterPlateEdgeProperties'
export const adapterPlateConnection = 'AdapterPlateConnection'
export const adapterHead = 'AdapterHead'
export const adapterHeadEdge = 'AdapterHeadEdge'
export const adapterHeadConnection = 'AdapterHeadConnection'
export const adapterHeadEdgeProperties = 'AdapterHeadEdgeProperties'
export const adapterPlateLayer = 'AdapterPlateLayer'
export const adapterPlateLayerProperties = 'AdapterPlateLayerProperties'
export const adapterPlateLayerEdge = 'AdapterPlateLayerEdge'
export const adapterPlateLayerConnection = 'AdapterPlateLayerConnection'

export const cover = 'Cover'
export const coverProperties = 'CoverProperties'
export const coverEdge = 'CoverEdge'
export const coverPlate = 'CoverPlate'
export const coverPlateProperties = 'CoverPlateProperties'
export const coverPlateEdge = 'CoverPlateEdge'
export const coverPlateEdgeProperties = 'CoverPlateEdgeProperties'
export const coverPlateConnection = 'CoverPlateConnection'

export const contentEdge = 'ContentEdge'
export const contentEdgeProperties = 'ContentEdgeProperties'
export const printedcircuitboard = 'Printedcircuitboard'
export const printedcircuitboardProperties = 'PrintedcircuitboardProperties'

export const elementConnection = 'ElementConnection'
export const elementEdge = 'ElementEdge'
export const circularClippingElement = 'CircularClippingElement'
export type CircularClippingElement = typeof circularClippingElement
export const circularEngravingElement = 'CircularEngravingElement'
export type CircularEngravingElement = typeof circularEngravingElement
export const rectangularClippingElement = 'RectangularClippingElement'
export type RectangularClippingElement = typeof rectangularClippingElement
export const rectangularEngravingElement = 'RectangularEngravingElement'
export type RectangularEngravingElement = typeof rectangularEngravingElement
export const textEngravingElement = 'TextEngravingElement'
export type TextEngravingElement = typeof textEngravingElement
export type EngravingElement =
  | TextEngravingElement
  | RectangularEngravingElement
  | CircularEngravingElement
export type ClippingElement =
  | CircularClippingElement
  | RectangularClippingElement
export type Element = EngravingElement | ClippingElement

export const project = 'Project'
export const projectProperties = 'ProjectProperties'
export const accessoryConnection = 'AccessoryConnection'
export const accessoryEdgeProperties = 'AccessoryEdgeProperties'
export const contentConnection = 'ContentConnection'
export const enclosureConnection = 'EnclosureConnection'

export const fastener = 'Fastener'
export const fastenerEdge = 'FastenerEdge'
export const fastenerConnection = 'FastenerConnection'
export const fastenerComponentEdge = 'FastenerComponentEdge'
export const fastenerComponentConnection = 'FastenerComponentConnection'
export const brackets = 'Brackets'
export const bracketsEdge = 'BracketsEdge'
export const bracketsEdgeProperties = 'BracketsEdgeProperties'
export const distanceBolts = 'DistanceBolts'
export const distanceBoltsEdge = 'DistanceBoltsEdge'

export const nuts = 'Nuts'
export const nutsProperties = 'NutsProperties'
export const nutsEdge = 'NutsEdge'
export const screws = 'Screws'
export const screwsProperties = 'ScrewsProperties'
export const screwsEdge = 'ScrewsEdge'
export const feets = 'Feets'
export const feetsProperties = 'FeetsProperties'
export const feetsEdge = 'FootEdge'

export type Typename =
  | typeof editor
  | typeof configuration
  | typeof preview
  | typeof width
  | typeof height
  | typeof thickness
  | typeof length
  | typeof border
  | typeof borderSide
  | typeof gap
  | typeof gapSide
  | typeof offset
  | typeof adapter
  | typeof adapterEdge
  | typeof adapterPlate
  | typeof adapterPlateProperties
  | typeof adapterPlateEdge
  | typeof adapterPlateEdgeProperties
  | typeof adapterPlateConnection
  | typeof adapterHead
  | typeof adapterHeadEdge
  | typeof adapterHeadEdgeProperties
  | typeof adapterHeadConnection
  | typeof adapterPlateLayer
  | typeof adapterPlateLayerProperties
  | typeof adapterPlateLayerEdge
  | typeof adapterPlateLayerConnection
  | typeof cover
  | typeof coverProperties
  | typeof coverEdge
  | typeof coverPlate
  | typeof coverPlateProperties
  | typeof coverPlateEdge
  | typeof coverPlateEdgeProperties
  | typeof coverPlateConnection
  | typeof contentEdge
  | typeof contentEdgeProperties
  | typeof printedcircuitboard
  | typeof printedcircuitboardProperties
  | typeof solderSide
  | typeof componentSide
  | typeof elementConnection
  | typeof elementEdge
  | typeof circularClippingElement
  | typeof circularEngravingElement
  | typeof rectangularClippingElement
  | typeof rectangularEngravingElement
  | typeof textEngravingElement
  | typeof project
  | typeof projectProperties
  | typeof contentConnection
  | typeof enclosureConnection
  | typeof accessoryConnection
  | typeof accessoryEdgeProperties
  | typeof nuts
  | typeof nutsProperties
  | typeof nutsEdge
  | typeof screws
  | typeof screwsProperties
  | typeof screwsEdge
  | typeof feets
  | typeof feetsProperties
  | typeof feetsEdge
  | typeof fastener
  | typeof fastenerEdge
  | typeof fastenerConnection
  | typeof fastenerComponentEdge
  | typeof fastenerComponentConnection
  | typeof brackets
  | typeof bracketsEdge
  | typeof bracketsEdgeProperties
  | typeof distanceBolts
  | typeof distanceBoltsEdge
